import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { PropsWithChildren, useEffect } from "react";
import { persister, queryClient } from "src/providers/queryClient";

export { persister } from "src/providers/queryClient";

const WithTanStackQuery: React.FC<PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    const handleControllerChange = async () => {
      queryClient.removeQueries();
      await persister.removeClient();
    };

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener(
        "controllerchange",
        handleControllerChange
      );

      return () => {
        navigator.serviceWorker.removeEventListener(
          "controllerchange",
          handleControllerChange
        );
      };
    }
  }, []);

  return (
    <PersistQueryClientProvider
      persistOptions={{ persister }}
      client={queryClient}
    >
      {children}
    </PersistQueryClientProvider>
  );
};

export default WithTanStackQuery;
